import { BlogSection, DeveloperBlogSectionProps } from './blog-section';
import withEvents from 'analytics/withEvents';

const BlogSectionWithEvents = withEvents<DeveloperBlogSectionProps>(sendEvent => ({
  onCarouselScroll: (direction: 'left' | 'right', isMobile: boolean) => sendEvent('article_carousel_scroll', 'article', {
    event: {
      direction,
      action: isMobile ? 'swipe' : 'click',
    },
  }),
}))(BlogSection);

export default BlogSectionWithEvents;
